/* global window */
import React from 'react';
import {
  CheckOutlined,
  StockOutlined,
  TeamOutlined,
  DashboardFilled,
  SettingOutlined,
  ToolFilled,
  PoweroffOutlined,
  InfoCircleOutlined,
  MenuUnfoldOutlined,
  MenuFoldOutlined,
  UserOutlined,
  VideoCameraOutlined,
  HomeOutlined,
  CarOutlined,
  UploadOutlined,
  RocketFilled,
  ShopFilled,
  TagsFilled,
  ReadFilled,
  LayoutFilled,
  SignalFilled,
  LikeFilled,
  HomeFilled,
  NotificationFilled,
  CalendarFilled,
  RobotFilled,
  CheckSquareFilled
} from '@ant-design/icons';
import { GiIceSkate } from 'react-icons/gi';
import { HiUserGroup } from 'react-icons/hi';
import { Layout, Menu, Row, Col, Space, Button, Popover } from 'antd';
import LogoSmall from '../../static/logo-small.png';
import logo from 'src/static/logo-white.svg';
import logoOpen from "src/static/logo-open.svg";
import logoPowered from "src/static/logo-powered.svg";
import logoClosed from "src/static/logo-close.svg";
import { withRouter, Link } from 'react-router-dom';
import { connect } from 'react-redux';
import styled from 'styled-components';
import { Cookies } from 'react-cookie';
import { getSidebarCollapsed } from 'src/redux/selectors';
import { collapseSidebar } from 'src/redux/actions/status';
import { useIsMobile } from 'src/utils/responsive';
import { MenuItem } from 'rc-menu';
import { BiRocket } from 'react-icons/bi';

const StyledLink = styled(Link)`
  font-size: 15px;
  color: white !important;
  :hover {
    text-decoration: none !important;
  }
  .anticon svg {
    display: inline-block;
    font-size: 20px !important;
    color: black !important;
  }
`;

const { Sider } = Layout;

const Sidebar = props => {
  const isMobile = useIsMobile();

  const signOut = () => {
    // if (window.cordova) {
    //   window.FirebasePlugin.getToken(
    //     token => {
    //       window.pubnub.push.deleteDevice(
    //         {
    //           device: token,
    //           pushGateway: 'gcm' // apns, gcm, mpns
    //         },
    //         function (status) {
    //           if (status.error) {
    //             console.log('operation failed w/ error:', status);
    //           }
    //         }
    //       );
    //     },
    //     error => {
    //       console.error(error);
    //     }
    //   );
    // }

    // const cookies = new Cookies();
    // cookies.remove('token');
    // cookies.remove('basic');
    // localStorage.clear();
    // window.location.reload();
  };

  return (
    <Sider
      // collapsed={true}
      collapsed={props.collapsed}
      width={300}
      // On mobile the sidebar leaves the flow entirely when collapsed and
      // overlays the page when open, so the content gets the full width.
      collapsedWidth={isMobile ? 0 : 80}
      trigger={isMobile ? null : '>'}
      onCollapse={props.collapseSidebar}
      collapsible
      style={{
        position: "fixed",
        backgroundColor: "black",
        border: "none",
        borderRadius: "1em 1em 0em 0em",
        minHeight: "100vh",
        boxShadow: "4px 4px 4px rgba(0, 0, 0, 0.02)",
        zIndex: isMobile ? 99 : undefined,
        // borderRight: "1px solid rgba(0, 0, 0, 0.07)"
      }}
    >
      <div style={{ margin: "auto", textAlign: "center" }}>
        <img
          // onClick={props.collapseSidebar}
          style={{ margin: "auto", width: !props.collapsed ? "20em" : "4em", marginBottom: !props.collapsed ? "0.7em" : "0em", marginTop: !props.collapsed ? "2em" : "2em", padding: !props.collapsed ? "0.5em" : "0.5em", paddingTop: 0, paddingBottom: 0 }}
          alt="Profile"
          src={props.collapsed ? logoClosed : logoOpen}
        />
      </div>
      <Menu
        theme="dark"
        mode="inline"
        defaultSelectedKeys={['dashboard']}
        onClick={() => {
          if (isMobile && !props.collapsed) {
            props.collapseSidebar();
          }
        }}
        style={{ background: 'transparent', marginTop: '3vh' }}
      >
        <Menu.Item
          onClick={
            isMobile
              ? undefined
              : props.collapsed
                ? null
                : props.collapseSidebar
          }
          key='dashboard'
          icon={
            <LayoutFilled style={{ fontSize: "20px", color: "white" }} />
          }
        >
          <StyledLink to='/admin/dashboard'>
            <span>Dashboard</span>
          </StyledLink>
        </Menu.Item>
        {!isMobile && (
          <Menu.Item
            icon={
              <HomeFilled
                style={{
                  fontSize: "20px",
                  color: "white",
                  marginTop: props.collapsed ? "0.5em" : 0,
                }}
              />
            }
            key="sitemanagement"
          >
            <StyledLink to="/admin/sitemanagement">
              <span>Site Management</span>
            </StyledLink>
          </Menu.Item>
        )}
        {!isMobile && (
          <Menu.Item
            onClick={
              props.collapsed ? null : props.collapseSidebar
            }
            key="usermanagement"
            icon={
              <RobotFilled
                style={{
                  fontSize: "20px",
                  color: "white",
                  marginTop: props.collapsed ? "0.5em" : 0,
                }}
              />
            }
          >
            <StyledLink to="/admin/users">
              <span>User Management</span>
            </StyledLink>
          </Menu.Item>
        )}
        <Menu.Item
          onClick={
            isMobile
              ? undefined
              : props.collapsed
                ? null
                : props.collapseSidebar
          }
          key="stock"
          icon={
            <SignalFilled style={{ fontSize: '20px', color: "white", marginTop: "" }} />
          }
        >
          <StyledLink to="/admin/stock">
            <span>Sales Management</span>
          </StyledLink>
        </Menu.Item>

        <Menu.Item
          icon={
            <NotificationFilled
              style={{
                fontSize: "20px",
                color: "white",
                marginTop: props.collapsed ? "0.5em" : 0,
              }}
            />
          }
          key="specialgmanagement"
        >
          <StyledLink to="/admin/specialmanagement">
            <span>Action Plan</span>
          </StyledLink>
        </Menu.Item>
        <Menu.Item
          icon={
            <CalendarFilled
              style={{
                fontSize: "20px",
                color: "white",
                marginTop: props.collapsed ? "0.5em" : 0,
              }}
            />
          }
          key="tailoringmanagement"
        >
          <StyledLink to="/admin/tailoringmanagement">
            <span>Off and Leave Management</span>
          </StyledLink>
        </Menu.Item>
        <Menu.Item
          icon={
            <CheckSquareFilled
              style={{
                fontSize: "20px",
                color: "white",
                marginTop: props.collapsed ? "0.5em" : 0,
              }}
            />
          }
          key="checklists"
        >
          <StyledLink to="/admin/checklists">
            <span>Checklists</span>
          </StyledLink>
        </Menu.Item>
        <Menu.Item
          icon={
            <LikeFilled
              style={{
                fontSize: "20px",
                color: "white",
                marginTop: props.collapsed ? "0.5em" : 0,
              }}
            />
          }
          key="experiencemanagement"
        >
          <StyledLink to="/admin/experiencemanagement">
            <span>Guest Experience            </span>
          </StyledLink>
        </Menu.Item>

        {/* <Menu.Item
          onClick={props.collapsed ? null : props.collapseSidebar}
          key="pexunits"
          icon={<HomeOutlined style={{ fontSize: '20px', color: 'black' }} />}
        >
          <StyledLink to="/admin/pexunit">
            <span>Home View Management</span>
          </StyledLink>
        </Menu.Item> */}
        {/* <Menu.Item

          key="settings"

        >
          <StyledLink to="/admin/account">
            <SettingOutlined
              type="check"
              style={{
                fontSize: '20px',
                paddingRight: '12px',
                color: 'red'
              }}
            />
            <span>Settings</span>
          </StyledLink>
        </Menu.Item> */}
        {/* <Menu.Item onClick={props.collapseSidebar} key="pexrequests">
          <StyledLink to="/admin/pexrequests">
            <SettingOutlined
              type="check"
              style={{
                fontSize: '20px',
                paddingRight: '12px',
                color: '#f15b2b'
              }}
            />
            <span style={{ fontSize: '15px' }}>PEX Requests</span>
          </StyledLink>
        </Menu.Item> */}
        {/* <Menu.Item onClick={props.collapseSidebar} key="requests">
          <StyledLink to="/admin/requests">
            <CheckOutlined
              type="check"
              style={{
                fontSize: '20px',
                paddingRight: '12px',
                color: '#f15b2b'
              }}
            />
            <span style={{ fontSize: '15px' }}>Requests</span>
          </StyledLink>
        </Menu.Item> */}
      </Menu>
      {!isMobile ? 
      <div style={{ margin: "auto", textAlign: "center" }}>
        <img
          // onClick={props.collapseSidebar}
          style={{
            margin: "auto",
            position: "absolute",
            left: 0,
            right: 0,
            bottom: "8em",
            width: !props.collapsed ? "10em" : "6em",
            marginBottom: !props.collapsed ? "0.7em" : "0em",
            marginTop: !props.collapsed ? "2em" : "2em",
            padding: !props.collapsed ? "0.5em" : "0.5em", paddingTop: 0, paddingBottom: 0
          }}
          alt="Profile"
          src={logoPowered}
        />
      </div> : null}
    </Sider>
  );
};

const mapStateToProps = state => {
  return {
    collapsed: getSidebarCollapsed(state)
  };
};

const mapDispatchToProps = {
  collapseSidebar
};

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(Sidebar)
);
